import React, { useState } from 'react'
import CustomizedDialogs from '../../common/CustomizedDialogs'
import { formatDate1 } from '../../utils/helpers'
import dayjs from 'dayjs'
import { Box, Divider } from '@mui/material'
import CustomDatePicker from '../../common/CustomDatePicker'
import MButton from '../../common/MButton'
import { useSelector } from 'react-redux'
import { encryptText } from '../../utils/encrypt'

const EnquiryTwoModal = (props) => {
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    const { open = false, titleText = '', onClose = () => { }, bkgDeatails = {} } = props
    const [dateFilter, setDateFilter] = useState(formatDate1(dayjs(bkgDeatails?.tripDetails?.JourneyDate, 'DD-MMM-YYYY')))
    return (
        <CustomizedDialogs
            open={open}
            titleText={titleText}
            width={'400px'}
            height={'auto'}
            onClose={onClose}
            padding={'0px'}
        >
            <Box
                sx={{
                    padding: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                }}
            >
                <Box className="date_pickerV40">
                    <CustomDatePicker
                        label="Date"
                        id=""
                        selectedDate={dateFilter}
                        onChange={(date) => {
                            setDateFilter(date)
                        }}
                        minDate={null}
                    />
                </Box>
            </Box>

            <Divider sx={{ borderColor: "#cccccc" }} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "end",
                    gap: "8px",
                    padding: "12px 16px",
                }}
            >
                <MButton
                    variant="outlined"
                    btnName="Close"
                    onClick={onClose}
                />
                <MButton
                    btnName="Generate"
                    onClick={() => {

                        const params = {
                            dtJourneyDate: dayjs(dateFilter).format('DD-MMM-YYYY'),
                            TripTime: bkgDeatails.tripDetails.TripTime,
                            intAgentID: userDetails?.AgentID,
                        }
                        window.open(`/inquriyTwoReport?data=${encodeURIComponent(encryptText(JSON.stringify(params)))}`, "_blank");
                    }}
                />
            </Box>
        </CustomizedDialogs>
    )
}

export default EnquiryTwoModal